import { generatePath, useLocation, useParams } from 'react-router'

import { useAuth } from '@/modules/authentication'
import {
  useDigitalSmartZonesProductAccess,
  useGetDigitalSmartZonesLandingPage,
  useGetMobilityLandingPage,
  useGetParkingInsightsLandingPage,
  useGetRegulationsLandingPage,
  useMobilityAccess,
  useParkingInsightsProductAccess,
  useRegulationsProductAccess,
} from '@/modules/permissions/pageAccessHooks'
import { PARAMS } from '@/modules/urlRouting/paths'
import { SEGMENTS } from '@/modules/urlRouting/paths'

export const usePathWithNewRegionId = () => {
  const { pathname } = useLocation()
  const { regionId } = useParams()
  return (newRegionId: string) =>
    generatePathWithRegionId(
      regionId ? pathname.replace(regionId, `:${PARAMS.REGION_ID}`) : pathname,
      newRegionId
    )
}

export const generatePathWithRegionId = (path: string, regionId?: string) =>
  generatePath(path, { [PARAMS.REGION_ID]: regionId })

export const useProfilePageAccess = () => {
  const { data: currentUser } = useAuth()
  return !!currentUser?.providerData.some(provider => provider?.providerId === 'password')
}

export const removeRegionIdFromPath = (path: string | undefined) => {
  if (path === undefined) return ''

  return path.split('/').slice(2).join('/')
}

export const useProductOptions = () => {
  const hasParkingInsights = useParkingInsightsProductAccess()
  const hasRegulations = useRegulationsProductAccess()
  const hasDigitalSmartZones = useDigitalSmartZonesProductAccess()
  const hasMobility = useMobilityAccess()

  return [
    {
      disabled: !hasParkingInsights,
      product: SEGMENTS.ELEVATE,
      landingPage: useGetParkingInsightsLandingPage(),
      text: 'Elevate',
    },
    {
      disabled: !hasRegulations,
      product: SEGMENTS.REGULATIONS,
      landingPage: useGetRegulationsLandingPage(),
      text: 'Regulations',
    },
    {
      disabled: !hasDigitalSmartZones,
      product: SEGMENTS.MANAGEMENT,
      landingPage: useGetDigitalSmartZonesLandingPage(),
      text: 'Digital Smart Zones',
    },
    {
      disabled: !hasMobility,
      product: SEGMENTS.MOBILITY,
      landingPage: useGetMobilityLandingPage(),
      text: 'Mobility Manager',
    },
  ]
}
